import React, { useState } from 'react'

import styled from 'styled-components'
import Zoom from 'react-medium-image-zoom'
import MobilePinchZoomDialog from '../../atoms/MobilePinchZoomDialog/MobilePinchZoomDialog'
import { useIsMobile } from '../../../hooks/useIsMobile'

const MobileImageWrap = styled.div`
  padding: 0;
  border: none;
  background: transparent;
  width: 100%;
`

export default function PinchZoomWrap({ children, zoomMargin = 45, ariaLabel = 'Zoom image' }) {
  const [isOpen, setIsOpen] = useState(false)
  const isMobile = useIsMobile()

  return isMobile ? (
    <>
      <MobileImageWrap type="button" aria-label={ariaLabel} onClick={() => setIsOpen(true)}>
        {children}
      </MobileImageWrap>

      <MobilePinchZoomDialog open={isOpen} onClose={() => setIsOpen(false)}>
        {children}
      </MobilePinchZoomDialog>
    </>
  ) : (
    <Zoom zoomMargin={zoomMargin} classDialog="custom-zoom">
      {children}
    </Zoom>
  )
}
